import React from "react";
import ReactDOM from "react-dom";
import "./Assets/styles/index.css";
import { NavProvider } from "./context-api/nav-context";
import { QuoteProvider } from "./context-api/quote-context";
import { PopupProvider } from "./context-api/popup-context";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <NavProvider>
      <QuoteProvider>
        <PopupProvider>
          <App />
        </PopupProvider>
      </QuoteProvider>
    </NavProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
